<template>

    <div class="relative suggestive-search prose">
        <div class="input-form">
            <form :action="formActionSearch" method="GET" @submit="doSubmit">
                <label class="w-full text-center text-white text-fh3" :style="foregroundTextStyle" for="search">Search</label>
                <div class="flex flex-nowrap content-center items-center">
                    <input type="text" id="Search" name="Search" v-on:keyup="updateQuery" v-model="holdingSearchTerm"
                           class="border-0 p-4" :style="inputStyle"
                           placeholder="What are you looking for?"/>
                    <button v-if="holdingSearchTerm" class="border-0 border-none p-0 btn -ml-[50px]"
                            type="submit">
                        <span class="ph ph-magnifying-glass no-underline border-0 p-0 w-[20px]"></span>
<!--                        <img :src="searchIcon" alt="Search icon" class="border-0 p-0 w-[20px]">-->
                    </button>
                    <a v-else :href="resultsPageClean" class="no-underline text-[22px] px-2" :style="foregroundTextStyle">
                        <span class="ph ph-magnifying-glass no-underline border-0 p-0 w-[20px]"></span>
<!--                        <img :src="searchIcon" alt="Search icon" class="border-0 p-0 w-[20px]">-->
                        <span class="sr-only">Search</span>
                    </a>
                </div>

            </form>
        </div>


        <div class="fixed bg-white text-center results top left max-w-2xl w-full">
            <div>
                <div v-for="term in readPages"
                     class="cursor-pointer overflow-hidden border border-l-4 p-4 "
                     v-on:click.prevent="goTo(term.absoluteLink)">
                    <p class="flex-1 text-fh5 font-bold text-left mb-0">
                        <a :href="term.absoluteLink">
                            {{ term.title }}
                        </a>
                    </p>
                    <div class="text-left">{{ term.summary }}</div>
                </div>
                <div v-if="readPages" class="cursor-pointer overflow-hidden border border-l-4 p-4">
                    <p class="flex-1 text-fh5 text-left mb-0">
                        <a :href="formActionSearch">
                            See All Results
                        </a>
                    </p>
                </div>
            </div>
            <div v-if="$apollo.queries.readPages.loading">
                Loading...
            </div>
        </div>


    </div>

</template>

<script>
import {debounce} from "lodash";
import gql from 'graphql-tag';

export default {
    name: "SuggestiveSearch",
    data: {
        holdingSearchTerm: '',
        searchTerm: ''
    },
    computed: {
        formActionSearch: function () {
            return decodeURIComponent(this.formAction) + '?Search=' + this.searchTerm + '&action_results=Go';
        },
        resultsPageClean: function () {
            return decodeURIComponent(this.formAction.replace('SearchForm/', ''));
        },
        inputStyle: function () {
            // return "background: red";
            return "color: var(" + this.color +'); placeholder: var('+ this.color +'); border-bottom: 1px solid var('+ this.color +')';
        },
        foregroundTextStyle: function () {
            return "color: var(" + this.color +'); text-decoration: none; border-bottom: 0;';
        }
    },
    props: {
        formAction: {
            type: String,
            required: false
        },
        searchIcon: {
            type: String,
            required: false
        },
        color: {
            type: String,
            required: false
        }
    },
    methods: {
        goTo: function (link) {
            if (link) {
                window.location.href = link;
            }
        },
        doSubmit: function () {
            window.location.href = this.formActionSearch;
        },
        updateQuery: _.debounce(
            function () {
                this.searchTerm = (this.holdingSearchTerm.length > 2) ? this.holdingSearchTerm : '';
            }, 700)
    },
    apollo: {
        readPages: {
            query: gql`
                query readPages($searchTerm: String!) {
                    readPages(filter: {allContent: { contains: $searchTerm } }, limit: 4) {
                        nodes {
                          title
                          summary
                          metaDescription
                          absoluteLink
                        }
                    }
                }
            `,
            variables() {
                return {
                    searchTerm: this.searchTerm
                }
            },
            skip() {
                return this.searchTerm.length <= 2;
            },
            update: data => data.readPages.nodes
        }
    },
}
</script>

<style scoped>

</style>
